import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=927c053a&scoped=true"
import script from "./Volume.vue?vue&type=script&lang=js"
export * from "./Volume.vue?vue&type=script&lang=js"
import style0 from "./Volume.vue?vue&type=style&index=0&id=927c053a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927c053a",
  null
  
)

export default component.exports